import React     from 'react';
import PropTypes from 'prop-types';
import Constants from '../../../flux/Constants';
import Translations from '../../../utils/Translations';

class AlbumDescriptionButtonsItem extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			checked: this.props.checked,
		};

		this.onClick = this.onClick.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.checked !== this.props.checked) {
			this.setState({checked: this.props.checked});
		}
	}

	/**
	 * @param {Event} e
	 */
	onClick(e) {
        if (this.props.showLikeBeforeBuy && !this.props.isVotingVisible) {
            return;
        }

		const checked = !this.state.checked;
		if (this.props.checkable) {
			this.setState(() => ({
				checked: checked,
			}));
		}
		if (this.props.onClick) {
			this.props.onClick(e, checked);
		}
	}

	render() {
		const {
			      baseClassName,
			      icon,
			      iconChecked,
			      text,
			      tooltipText,
		      }         = this.props;
		const {checked} = this.state;
        const tooltipId = this.props.tooltipPosition === Constants.Tooltip.place.Top ? 'tooltip' : 'tooltip-' + this.props.tooltipPosition;
        const newTooltipText = this.props.showLikeBeforeBuy && !this.props.isVotingVisible ? Translations.get('tooltip.video-dislike-before-buy') : tooltipText;

		return (
			<div className={baseClassName + '-el '  + (this.props.showLikeBeforeBuy && !this.props.isVotingVisible ? baseClassName + '-el--disabled' : '')} onClick={this.onClick} data-tooltip-content={newTooltipText} data-tooltip-id={tooltipId} data-tooltip-variant={this.props.tooltipColor}>
				<i className={'icon ' + (checked ? iconChecked : icon)}></i>
				{this.props.isVotingVisible && (text !== null && text !== undefined) && <span className="value">{text}</span>}
			</div>
		);
	}
}

AlbumDescriptionButtonsItem.propTypes = {
	baseClassName: PropTypes.string,
	icon:          PropTypes.string,
	iconChecked:   PropTypes.string,
	text:          PropTypes.oneOfType([
						PropTypes.number,
						PropTypes.string
					]),
	onClick:       PropTypes.func,
	tooltipText:   PropTypes.string,
	checked:       PropTypes.bool,
	checkable:     PropTypes.bool,
    tooltipPosition: PropTypes.string,
    tooltipColor:    PropTypes.string,
    isVotingVisible: PropTypes.bool,
    showLikeBeforeBuy: PropTypes.bool,
};

AlbumDescriptionButtonsItem.defaultProps = {
	baseClassName: '',
	tooltipText:   '',
	checked:       false,
	checkable:     true,
    tooltipPosition: Constants.Tooltip.place.Top,
    tooltipColor:    Constants.Tooltip.Variant.Dark,
    isVotingVisible:    false,
    showLikeBeforeBuy: false,
};

export default AlbumDescriptionButtonsItem;
